<template>
  <el-drawer
      title="新建设计单"
      :wrapperClosable="false"
      :visible.sync="showDrawer"
      size="956"
      :append-to-body="true"
      direction="ltr">
    <div class="inner design-warp" v-if="designType" :key="designType.id">
      <div style="position: relative">
        <img class="design-img" :src="designType.item_comment" alt="">
        <Zwibbler ref="zwibbler" :width="916" :height="1242" :bottom="'80px'"></Zwibbler>
      </div>

      <div class="design-btn-outer">
        <div class="design-btn black-14" @click="submitAdd">提交</div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import {CreateCaseCard, CreateSjd} from "@/http/api";
import Zwibbler from '@/components/Zwibbler'
import ossUpload from "@/http/ossUpload";

export default {
  name: "index",
  components:{Zwibbler},
  data(){
    return{
      showDrawer:this.drawer,
      caseDetail:''
    }
  },
  props:{
    drawer:false,
    designType:null,
    patient_id:undefined
  },
  mounted() {
    console.log(this.designType)
  },
  methods:{
    submitAdd(){
      let blob = this.$refs.zwibbler.saveTu()
      ossUpload.bucketUpload(blob, (res) => {
        this.createCard(res.url)
      }, (err) => {
        this.createCard('')
      }, 'duole-images', '/upload/image/pc/new_sjd_pz')
    },
    createCard(img){
      let obj = {
        shejidan_type:this.designType.item_value,
        shejidan_img:this.designType.item_comment,
        pizhu_img:img
      }
      if(this.patient_id){
        obj.type_id = 5
        obj.patient_id = this.patient_id
        CreateCaseCard(obj).then(res=>{
          if(res.code == 200){
            this.$message({
              type:'success',
              message:'新建成功'
            })
            this.showDrawer = false
            this.$emit('designCardData', res.data)
          }else{
            this.$message({
              type:'error',
              message:res.message[0]
            })
          }
        })
      }else{
        CreateSjd(obj).then(res=>{
          if(res.code == 200){
            this.$message({
              type:'success',
              message:'新建成功'
            })
            this.showDrawer = false
            this.$emit('designCardData', res.data)
          }else{
            this.$message({
              type:'error',
              message:res.message[0]
            })
          }
        })
      }
    }
  }
}
</script>

<style scoped src="../../../../assets/css/case_management_add_case.css"></style>
<style scoped>
.add-data-item-input {
  position: relative;
}
.add-data-item-input input{
  width: 176px;
  height: 34px;
  background: #F4F4F4;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 14px;
  border: none;
  padding-left: 10px !important;
}
.add-data-item-input .el-input__prefix{
  left: 150px;
  top: -2px;
}
.add-data-item-input .el-icon-arrow-right{
  color: #B1B1B1;
  font-size: 12px;
  font-weight: bold;
}
.add-data-item-input .icon-youjiantou{
  position: absolute;
  right: 10px;
  color: #B1B1B1;
  font-size: 10px;
  top: 8px;
  font-weight: bold;
}
.add-data-item-input input::placeholder{
  color: rgba(60,60,67,0.3);
}
.add-data-item-input input:focus{
  background: rgba(254,212,0,0.05);
  border: 1px solid #FED400;
}
</style>
